<template>
<div class="overview-delivery">

  <vue-headful
    title="TZ Design Box - Overview Delivery"
    description="TZ Design Box"
/>

  <div class="container">
    <div class="columns">
      <div class="column is-2 menu-vert">
        <MenuVert :currentactive="'overview-delivery'" />
      </div>
      <div class="column is-10" style="margin-top:25px;">
        <Breadcrumbs/>
        <hr>
        <div class="content">
          <h2>{{ $t("overview-delivery") }}</h2>
          <p>{{ $t("delivery-overview-details") }}</p>
          <table class="table">
          <thead>
            <tr>
                <th>{{ $t("name1") }}</th>
                <th>{{ $t("address1") }}</th>
                <th>{{ $t("zip") }}+{{ $t("city") }}</th>
                <th>{{ $t("country") }}</th>
                <th>{{ $t("email") }}</th>
                <th>{{ $t("active") }}</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="delivery in getDeliveryAdresses" :key="delivery.id">
                    <td>{{delivery.name1}}</td>
                    <td>{{delivery.address1}}</td>
                    <td>{{delivery.zip}} {{delivery.city}}</td>
                    <td>{{delivery.country}}</td>
                    <td>{{delivery.email}}</td>
                    <td>
                      <b-checkbox v-model="delivery.active" name="deliver_active" @input="changeActive(delivery)">
                      </b-checkbox>                    
                    </td>
                    <td>
                        <a class="button" v-if="delivery.active">
                          <router-link :to="'/edit-delivery/?address='+delivery.id">{{ $t("edit") }}</router-link>
                        </a>
                    </td>
                    <td>
                      <a class="button is-outlined is-info"
                         v-if="!delivery.is_delivery && delivery.active"
                         @click="setActiveDeliveryAddress (delivery.id)"
                         >{{ $t ("select") }}
                      </a>
                      <span v-else>&nbsp;</span>
                      </td>
                </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MenuVert         from '@/components/MenuVert'
import Breadcrumbs      from '@/components/Breadcrumbs'
import { mapGetters }   from 'vuex'

export default {
    name:'OverviewDelivery',
    computed: { ...mapGetters([
        "getCurrentCompany", "getDeliveryAdresses", "getCompany"]),
        cid: {
            get () { return this.getCompany}
        },
    },
    components:{ MenuVert, Breadcrumbs},
    methods: {
        setActiveDeliveryAddress(id) {
            let self = this
            this.$store.dispatch (
                "changeDeliveryAddress", {self: self, cid: this.cid, id: id})
        },
        changeActive(delivery) {
          const newState = ! delivery.active
          this.$store.dispatch (
                "changeDeliveryAddressInactive", {cid: this.cid, id : delivery.id, inactive : newState})
        },
        update () {
            const self     = this
            let  cid       = this.getCompany
            const redirect = this.$route.query.redirect
            // console.log ("OverviewDelivery: Redirect", redirect, "cid", cid)
            this.$store.dispatch ("callDeliveryAdresses",{self: self, company: cid, redirect: redirect})
        }

    },
    beforeRouteUpdate (to, from, next) {
        this.update ()
        next ()
    },
    mounted () {
        this.update ()
    }
}
</script>

<style>
.overview-delivery{
    padding-bottom:50px;
}
.content{
    background-color:#fff!important;
    padding:25px;
    box-shadow: 0 1px #FFFFFF inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}
</style>
